var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16732 2.22249H12.834V10.2225H2.94732L2.16732 11.0025V2.22249ZM2.16732 0.88916C1.43398 0.88916 0.840651 1.48916 0.840651 2.22249L0.833984 14.2225L3.50065 11.5558H12.834C13.5673 11.5558 14.1673 10.9558 14.1673 10.2225V2.22249C14.1673 1.48916 13.5673 0.88916 12.834 0.88916H2.16732ZM3.50065 7.55583H8.83398V8.88916H3.50065V7.55583ZM3.50065 5.55583H11.5007V6.88916H3.50065V5.55583ZM3.50065 3.55583H11.5007V4.88916H3.50065V3.55583Z",
    fill: "#F9C416"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.5fb49cb14848e8452d32d0b3e063f2bb.svg";
export { ForwardRef as ReactComponent };